import { EventEmitter } from 'events';

export class WebSocketManager extends EventEmitter {
	private static instance: WebSocketManager;
	private socket: WebSocket;

	private constructor(url: string) {
		super();

		// Conectando ao WebSocket
		this.socket = new WebSocket(url);

		// Quando a conexão é aberta
		this.socket.addEventListener('open', () => {
			console.log('Conectado ao WebSocket');
			this.emit('connected'); // Emitir evento de conexão
		});

		// Quando uma mensagem é recebida
		this.socket.addEventListener('message', event => {
			this.handleMessage(event.data);
		});

		// Quando ocorre um erro
		this.socket.addEventListener('error', error => {
			console.error('Erro no WebSocket:', error);
			this.emit('error', error); // Emitir evento de erro
		});

		// Quando a conexão é fechada
		this.socket.addEventListener('close', () => {
			console.log('Conexão WebSocket fechada');
			this.emit('closed'); // Emitir evento de fechamento
		});
	}

	// Método para criar ou retornar a instância existente
	public static getInstance(url: string): WebSocketManager {
		if (!WebSocketManager.instance) {
			WebSocketManager.instance = new WebSocketManager(url);
		}
		return WebSocketManager.instance;
	}

	// Lida com as mensagens recebidas
	private handleMessage(data: string) {
		const message = JSON.parse(data);

		// Verifica se há uma ação e um payload na mensagem
		if (message.action && message.payload) {
			console.log(`Comando recebido: ${message.action}`, message.payload);

			// Emitir um evento 'websocketAction' com a ação e o payload da mensagem
			this.emit('websocketAction', message.action, message.payload);
		}
	}

	// Enviar uma mensagem pelo WebSocket
	public send(action: string, payload: any) {
		const message = JSON.stringify(payload);
		this.socket.send(message);
	}
}
